module.exports = __webpack_public_path__ + "static/media/a2.6346b81c.jpg";